import './navbar.scss';

import logo from '../../images/logo.svg';
import cpanel from '../../images/cpanel.svg';
import userIcon from '../../images/profile.svg';
import settingIcon from '../../images/settings.svg';
import logoutIcon from '../../images/logout.svg';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import axios from '../../api/axios';

function Navbar() {
  const navigate = useNavigate();
  const [open,setOpen] = useState(false);
  const {auth} = useAuth();

  const handleLogout = async()=>{


    try {
      const logout = await axios.get('/logout');
      if(logout){
        setOpen(false);
        navigate('/cpanel/login/');
      }
    } catch (error) {
      console.log(error.message);
    }
    

  }
  return (
    <div className='navbar'>

      <div className="logo">
        <img src={logo} alt="" />
        <span><img src={cpanel} width={100} height={48} alt="" /></span>
      </div>

      <div className="icons">
        <div className="user">
          <img src={userIcon} alt="" />
          <span>{`${auth.username} -- (${auth.roles})`}</span>
        </div>
        <img src={settingIcon} alt="" onClick={()=>setOpen(!open)}/>
      </div>
      {open && <div className="logout" onClick={handleLogout}><img src={logoutIcon} alt="" /> Logout ({auth.username})</div>}
    </div>
  )
}

export default Navbar 